import React from 'react';
import { useAnimateOnView } from '../../hooks/useIntersectionObserver';
import { SectionProps } from '../../types';
import './Section.css';

interface SectionComponentProps extends SectionProps {
  id: string;
  title?: string;
  subtitle?: string;
  showDecorations?: boolean;
  paddingClass?: string;
}

/**
 * Componente Section - Wrapper reutilizable para secciones
 * Incluye animaciones de entrada y decoraciones opcionales
 */
const Section: React.FC<SectionComponentProps> = ({
  id,
  title,
  subtitle,
  children,
  className = '',
  showDecorations = true,
  paddingClass = 'section-padding'
}) => {
  const [ref, shouldAnimate] = useAnimateOnView();

  return (
    <section
      ref={ref}
      className={`${paddingClass} ${shouldAnimate ? 'loaded' : ''} ${className}`}
      id={id}
    >
      {/* Decoraciones de sección */}
      {showDecorations && (
        <div className="section-decoration">
          <div className="decoration-circle"></div>
          <div className="decoration-dots"></div>
        </div>
      )}

      <div className="container">
        {/* Header de sección */}
        {(title || subtitle) && (
          <div className="section-header site-section-header">
            {title && (
              <h2 className="section-title site-section-title">
                <span>{title}</span>
              </h2>
            )}
            {subtitle && <p className="section-subtitle site-section-subtitle">{subtitle}</p>}
          </div>
        )}

        {/* Contenido de la sección */}
        {children}
      </div>
    </section>
  );
};

export default Section;